import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useContext } from '../../Context'
import { useConfirmDialog } from '@ztechapps/common.hook'
import { TooltipPopOver } from '@ztechapps/webui.util'

export const ResetFilterMenuItem = () => {
  const { onReset } = useContext()

  const { onConfirm } = useConfirmDialog({
    title: 'Reset Filters & Sorting?',
    text: 'This will reset search, filters, sorting, and return to page 1.',
    buttons: {
      confirm: {
        text: 'Yes, reset it!',
      },
    },
    confirmed: onReset,
  })

  return (
    <TooltipPopOver tooltipBody="Reset search, filters, sorting, and return to page 1.">
      <Dropdown.Item onClick={onConfirm}>
        <div>Reset filters...</div>
      </Dropdown.Item>
    </TooltipPopOver>
  )
}
